import { Modal } from './Modal';

export interface DetailField {
  label: string;
  /** The value to show - a plain string/number, or a React node (e.g. a StatusBadge) for richer display. Falsy/empty (string/number/null/undefined only) renders as an explicit "-", never a blank cell that looks broken; a React node is never treated as empty. */
  value: string | number | React.ReactNode | null | undefined;
  /** Optional - for longer free text (justification, description, comments) rendered as a full-width block instead of a label/value row. */
  fullWidth?: boolean;
}

interface RecordDetailModalProps {
  title: string;
  fields: DetailField[];
  onClose: () => void;
  /** Optional extra content below the fields - e.g. a sub-table of lines, attachments, or a real audit trail. */
  children?: React.ReactNode;
}

/**
 * The shared, reusable "read what you're deciding on" view - built
 * once and applied consistently across every module's list, rather
 * than a bespoke detail page per module. Genuinely read-only: no
 * action buttons live here, so opening a record to read it is never
 * itself a decision. Every field renders even when empty, as an
 * explicit "-", so a missing value is visibly a gap rather than a
 * silently absent row a reader might not notice.
 */
export function RecordDetailModal({ title, fields, onClose, children }: RecordDetailModalProps) {
  return (
    <Modal title={title} onClose={onClose} wide>
      <div className="record-detail-grid">
        {fields.map((f) => (
          <div key={f.label} className={f.fullWidth ? 'record-detail-row-full' : 'record-detail-row'}>
            <div className="record-detail-label">{f.label}</div>
            <div className="record-detail-value">{f.value === null || f.value === undefined || f.value === '' ? '-' : f.value}</div>
          </div>
        ))}
      </div>
      {children}
    </Modal>
  );
}
